import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Twitter, MessageCircle, Phone, Mail, MapPin, Shield } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-dark-card border-t border-white/5 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center space-x-3">
              <img src="/logo-ati-icon.svg" alt="ATI" className="h-8 w-8" />
              <span className="text-xl font-bold text-white">Asistente Trading IA</span>
            </Link>
            <p className="text-gray-400 text-sm">
              Asistente institucional de trading para Nasdaq.
              Analiza el mercado y te avisa cuando hay ventaja estadistica.
            </p>
          </div>

          {/* Platform Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Plataforma</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/register" className="text-gray-400 hover:text-white transition-colors">
                  Crear Cuenta
                </Link>
              </li>
              <li>
                <Link to="/login" className="text-gray-400 hover:text-white transition-colors">
                  Iniciar Sesion
                </Link>
              </li>
              <li>
                <Link to="/dashboard" className="text-gray-400 hover:text-white transition-colors">
                  Dashboard
                </Link>
              </li>
              <li>
                <Link to="/embajadores" className="text-gray-400 hover:text-white transition-colors">
                  Programa de Embajadores
                </Link>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="text-white font-semibold mb-4">Comunidad</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="https://discord.gg/cyf8tgdDyH"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center text-gray-400 hover:text-white transition-colors"
                >
                  <MessageCircle className="h-5 w-5 mr-2" />
                  Discord
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/asistentetradingia/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center text-gray-400 hover:text-white transition-colors"
                >
                  <Instagram className="h-5 w-5 mr-2" />
                  Instagram
                </a>
              </li>
              <li>
                <a
                  href="https://x.com/pjpalomares"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center text-gray-400 hover:text-white transition-colors"
                >
                  <Twitter className="h-5 w-5 mr-2" />
                  Twitter
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contacto</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="tel:+34619410431"
                  className="flex items-center text-gray-400 hover:text-white transition-colors"
                >
                  <Phone className="h-5 w-5 mr-2" />
                  +34 619 410 431
                </a>
              </li>
              <li>
                <a
                  href="mailto:info@asistentetradingia.com"
                  className="flex items-center text-gray-400 hover:text-white transition-colors"
                >
                  <Mail className="h-5 w-5 mr-2" />
                  info@asistentetradingia.com
                </a>
              </li>
              <li>
                <div className="flex items-center text-gray-400">
                  <MapPin className="h-5 w-5 mr-2" />
                  Barcelona, Espana
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Legal + Disclaimer */}
        <div className="mt-12 pt-8 border-t border-white/5">
          <p className="text-center text-xs text-gray-500 mb-6">
            Trading de futuros implica riesgo de perdida. Rendimientos pasados no garantizan resultados futuros.
            Esta herramienta no constituye asesoramiento financiero.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex items-center justify-center md:justify-start space-x-4 text-sm">
              <Link to="/privacy" className="text-gray-400 hover:text-white transition-colors flex items-center">
                <Shield className="h-4 w-4 mr-1" />
                Politica de Privacidad
              </Link>
              <Link to="/terms" className="text-gray-400 hover:text-white transition-colors">
                Terminos y Condiciones
              </Link>
              <Link to="/cookies" className="text-gray-400 hover:text-white transition-colors">
                Politica de Cookies
              </Link>
            </div>
            <p className="text-center md:text-right text-gray-400 text-sm">
              &copy; {new Date().getFullYear()} Asistente Trading IA. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
